export default "__VITE_ASSET__BXAk6RDG__"